import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { ItemDetailsQueryType } from "../../../../../../utils/Enum.types";
import { PageInfo } from "../../../../customer/settings/predefinedList/queries/types";
import { AtsStckCompanyItemLdgr } from "../../items/queries/types";

export enum AtsSubsidiaryOrderField {
  CREATED_AT = "CREATED_AT",
  NAME = "NAME",
  PLACE = "PLACE",
}

export interface GetSubsidiariesVars extends commonPaginationTypes {
  customerID: number;
  companyID: number;
  empID: number;
  orderBy: {
    direction: OrderDirection;
    field: AtsSubsidiaryOrderField;
  };
  name: string;
}

export interface AtsSubsidiary {
  id: number;
  slNo: number;
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  isActive: string;
  panNo: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  timeZone: string;
  customerID: number;
  enableGst: boolean;
  enableTds: boolean;
  enableTcs: boolean;
  gstState: string;
  mobileNo: string;
  regType: string;
  telephone: string;
  companyID: number;
  subsidiarySiteDetails: {
    id: number;
    name: string;
    address: string;
  };
  icon: string
}

export interface AtsSubsidiaryEdge {
  node: AtsSubsidiary;
  cursor: string;
}

interface GetSubsidiariesData {
  edges: AtsSubsidiaryEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetSubsidiariesResult {
  GetSubsidiaries: GetSubsidiariesData;
}

//Mutations

interface CreateAtsSubsidiaryInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  panNo: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  isActive?: boolean;
  enableGst?: boolean;
  enableTds?: boolean;
  enableTcs?: boolean;
  timeZone?: string;
  icon: string
}

export interface AddSubsidiaryVar extends commonMutationTypes {
  input: CreateAtsSubsidiaryInput;
  customerID: number;
  companyID: number;
}

export interface AddSubsidiaryResult {
  AddSubsidiary: {
    id: number;
  };
}

export interface UpdateAtsSubsidiaryInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  url: string;
  logoFilename: string;
  panNo: string;
  gstNo: string;
  tanNo: string;
  vatNo: string;
  oth1No: string;
  oth2No: string;
  latitude: number;
  longitude: number;
  enableGst: boolean;
  enableTds: boolean;
  enableTcs: boolean;
  icon: string;
}

export interface UpdateSubsidiaryVar extends commonMutationTypes {
  input: UpdateAtsSubsidiaryInput;
  // customer_id: number;
  subsidiaryID: number;
}

export interface UpdateSubsidiaryResult {
  UpdateSubsidiary: {
    id: number;
  };
}

export interface AtsSubsidiarySite {
  id: number;
  name: string;
  slNo: number;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  latitude: string;
  longitude: string;
  gstNo: string;
  subsidiaryID: number;
  companyID: number;
  customerID: number;
  icon: string
}

export interface CreateAtsSubsidiarySiteInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  latitude: number;
  longitude: number;
  icon: string
}

export interface UpdateAtsSubsidiarySiteInput {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  isActive: string;
  latitude: number;
  longitude: number;
  icon: string
}

export interface AddSubsidiarySiteVar extends commonMutationTypes {
  input: CreateAtsSubsidiarySiteInput;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
}

export interface AddSubsidiarySiteResult {
  AddSubsidiarySite: boolean;
}

export interface UpdateSubsidiarySitesVar extends commonMutationTypes {
  input: UpdateAtsSubsidiarySiteInput;
  subsidiarySiteID: number;
}

export interface UpdateSubsidiarySiteResult {
  UpdateSubsidiarySite: boolean;
}
export interface AddSubsidiarySiteResult {
  AddSubsidiarySite: boolean;
}

export interface UpdateSubsidiarySiteVar extends commonMutationTypes {
  input: UpdateAtsSubsidiarySiteInput;
  subsidiary_site_id: number;
}

export interface UpdateSubsidiarySiteResult {
  UpdateSubsidiarySite: boolean;
}

export interface DeleteSubsidiaryByIdResult {
  DeleteSubsidiary: boolean;
}

export interface DeleteSubsidiaryByIdVars extends commonMutationTypes {
  subsidiaryID: number;
}

export interface AtsSubsidiarySiteEdge {
  node: AtsSubsidiarySite;
  cursor: string;
}

export interface AtsSubsidiarySiteConnection {
  edges: AtsSubsidiarySiteEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export enum AtsSubsidiarySiteOrderField {
  CREATED_AT = "CREATED_AT",
  NAME = "NAME",
  PLACE = "PLACE",
}

export interface AtsSubsidiarySiteOrder {
  direction: OrderDirection;
  field: AtsSubsidiarySiteOrderField;
}

export enum SiteQueryType {
  ALL = "ALL",
  BY_SUBSIDIARY_ID = "BY_SUBSIDIARY_ID",
}

export interface SiteQueryData {
  queryType: SiteQueryType;
  id: number;
}

export interface GetSubsidiarySitesVar extends commonPaginationTypes {
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  empID: number;
  orderBy: AtsSubsidiarySiteOrder;
  name: string;
}

export interface GetSubsidiarySitesResult {
  GetSubsidiarySites: AtsSubsidiarySiteConnection;
}

export interface DeleteSubsidiarySiteResult {
  DeleteSubsidiarySiteResult: boolean;
}

export interface DeleteSubsidiarySiteVar extends commonMutationTypes {
  subsidiarySiteID: number;
}

export interface AtsStckItemDetailsList {
  id: number;
  desc: string;
  slNo: number;
  ldgr_count: number;
  code: string;
  uom: string;
  hsnCode: string;
  enableGst: boolean;
  igst: number;
  sgst: number;
  cgst: number;
  isStockOrService: string;
  trackSerial: boolean;
  trackBrand: boolean;
  trackModel: boolean;
  trackBatch: boolean;
  trackExpiry: boolean;
  trackWarranty: boolean;
  trackInstallation: boolean;
  trackMaintenance: boolean;
  isPerishable: boolean;
  isConsumable: boolean;
  imageNeeded: boolean;
  trackAmc: boolean;
  trackGeoLocation: boolean;
  trackInsurance: boolean;
  isModule: boolean;
  isComponent: boolean;
  image_path: string;
  stckDetailsEntryNotNeeded: boolean;
  stckDetailsEntryIsSingle: boolean;
  stckDetailsEntryIsMultiple: boolean;
  additionalPropertyNeeded: boolean;
  noOfAdditionalProperties: number;
  AdditionalPropertyDesc1: string;
  AdditionalPropertyDesc2: string;
  AdditionalPropertyDesc3: string;
  AdditionalPropertyDesc4: string;
  AdditionalPropertyDesc5: string;
  AdditionalPropertyDesc6: string;
  AdditionalPropertyDesc7: string;
  AdditionalPropertyDesc8: string;
  AdditionalPropertyDesc9: string;
  AdditionalPropertyDesc10: string;
  AdditionalPropertyDatatype1: string;
  AdditionalPropertyDatatype2: string;
  AdditionalPropertyDatatype3: string;
  AdditionalPropertyDatatype4: string;
  AdditionalPropertyDatatype5: string;
  AdditionalPropertyDatatype6: string;
  AdditionalPropertyDatatype7: string;
  AdditionalPropertyDatatype8: string;
  AdditionalPropertyDatatype9: string;
  AdditionalPropertyDatatype10: string;
  customerID: number;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;

  categoryDetails: {
    categoryName: string;
  };
  subCategoryDetails: {
    subCategoryName: string;
  };

  groupDetails: {
    groupName: string;
  };
  manufacturerDetails: {
    manufacturer: string;
  };
  uomDetails: {
    uom: string;
    uomDesc: string;
  };

  inStockDetails: AtsStckCompanyItemLdgr;
}

interface ImportSiteDetails {
  subsidiaryName: string;
  siteName: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  latitude: number;
  longitude: number;
}

export interface ImportSubsidiarySiteResult {
  ImportSubsidiarySite: boolean;
}

export interface ImportSubsidiarySiteVars {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  input: ImportSiteDetails;
  user_details: userDetails;
}

export interface ExportSubsidiarySiteTemplateVars {
  token?: string;
  customerID: number;
  atSubsidiaryLevel: boolean;
}

export interface ExportSubsidiarySiteTemplateResult {
  ExportSubsidiarySiteTemplate: string;
}

export interface ValidateSubsidiarySiteForImportVars {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryName: string;
  siteName: string;
}

export interface ValidateSubsidiarySiteForImportResult {
  ValidateSubsidiarySiteForImport: boolean;
}
